import { render } from "./OrgSettingsHubPanel.vue?vue&type=template&id=6bde0c8a"
import script from "./OrgSettingsHubPanel.vue?vue&type=script&lang=js"
export * from "./OrgSettingsHubPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__